import moment from 'moment'
	export const getTimeLeft = value => {
		//DATE NOW
		let currentDate = moment((new Date()).toISOString());
		//END DATE
		let endDate = moment(value);
		//TIME LEFT
		let timeLeft = endDate.diff(currentDate, 'days');
		if(timeLeft >= 0) {
			return "-" + timeLeft
		}else{
			return "+" + (timeLeft * -1)
		}
	}
	export const formatDate = value => {
		let date = new Date(value);
		let year = date.getFullYear();
		let month = date.getMonth()+1;
		let day = date.getDate();

		if (day < 10) {
		  day = '0' + day;
		}
		if (month < 10) {
		  month = '0' + month;
		}
		return(day + '/' + month + '/' + year);
	}



// WEBPACK FOOTER //
// ./src/Util/index.js